import { createStore, createEffect } from 'effector/compat';
import { cookiesParse, getExpires } from '../utils/utils'
import uuidv1 from "uuid/v1";
import packageJSON from "../../package.json";
import { getCurrentChannel } from './channel-store';
import { altair } from 'antares';

const CONFIG_URL = `${process.env.PUBLIC_URL}/config.json`;

const AppStore = createStore({
    config: {},
    showTrigger: true,
    showMainApp: false,
    showPolls: false,
    appVersion: false
});

const getLocalConfig = createEffect('get-local-config').use((params) => {
    return fetch(CONFIG_URL)
        .then(response => response.json())
        .then(async (json) => {
            const {
                federated,
                changeTriggerTimer,
                tokenApp,
                silente,
                telemetryEnabled,
                activeTestButtons,
                saveOldPrivacyData,
                appVersion,
                channels
            } = json

            let expires = null;
            let _serialNumber = null;
            let geoURL = null;
            let telemetry = null;
            let telemetryAppName = null

            federated.map((app) => {
                if (app.type === 'PrivacyApp' && app.minuteTecnicalCookie) {
                    expires = app.minuteTecnicalCookie
                }
                if (app.type === 'TelemetryApp') {
                    telemetry = app.telemetry;
                    if (app.telemetry.serialNumber) {
                        _serialNumber = app.telemetry.serialNumber
                        telemetryAppName = app.appName
                    }
                    if (app.telemetry.geoURL) {
                        geoURL = app.telemetry.geoURL
                    }
                }
            })

            expires = getExpires(expires)

            console.log("[APP STORE][COOKIE] EXPIRES :", expires)

            let _serial = undefined;
            let _cookies = cookiesParse();

            let stored = _cookies?.find((c) => String(c.key).replace(/\s/g, "") === _serialNumber);

            const generatedSN = stored?.value;
            console.log("[APP STORE][COOKIE] SERIAL NUMBER :", stored, _cookies, _serialNumber);

            if (!generatedSN || generatedSN === null) {
                console.log("[APP STORE][COOKIE] CREATE CLIENTID :", generatedSN);
                const serialNumber = altair.getSerialNumber();
                if (serialNumber && serialNumber !== null) {
                    document.cookie = `${_serialNumber}=${serialNumber};${expires};path=/`;
                    _serial = serialNumber;
                } else {
                    const uuid = uuidv1();
                    document.cookie = `${_serialNumber}=${uuid};${expires};path=/`;
                    _serial = uuid;
                }
            } else {
                _serial = generatedSN;
            }

            console.log("[APP STORE][COOKIE] SERIAL NUMB :", _serial);

            if (_serial !== undefined) {
                const urlAuth = tokenApp.tokenizationURL;
                let oldToken = _cookies?.find((c) => String(c.key).replace(/\s/g, "") === 'kiss-kiss-token-api');
                const body = {
                    token: oldToken !== undefined ? oldToken.value : "",
                    client: _serial
                }
                if (tokenApp.secondsToExpiration !== undefined) {
                    body.expiration = tokenApp.secondsToExpiration;
                }
                await getGeoInformations(geoURL).then(async (information) => {
                    body.geo = information;
                    window.geoInfo = information;
                    await getCurrentChannel().then(async (channel) => {
                        console.log("[APP STORE][TOKEN] CHANNEL OBTAINED:", channel, information);
                        body.channel = channel.channel;

                        //CHECK APPLICATION NAME
                        let name = null;
                        channels.item.forEach((ch) => {
                            console.log("[APP STORE][TOKEN] CHANNEL :", ch, channel)
                            if (ch.triplet.onid === channel.channel.onid &&
                                ch.triplet.tsid === channel.channel.tsid &&
                                ch.triplet.sid === channel.channel.sid) {
                                name = ch.name
                                console.log("[APP STORE][TOKEN] CHANNEL FOUND :", name)
                            }
                        })

                        console.log("[APP STORE][TOKEN] APP NAME BEFORE :", name)


                        if (name === null) {
                            name = telemetryAppName
                        }

                        console.log("[APP STORE][TOKEN] APP NAME :", name, telemetryAppName);

                        body.channel.appName = name;
                        body.version = packageJSON.version;
                        body.telemetry = telemetry;

                        const getModelName = arrayUserAgent => {
                            if (arrayUserAgent && arrayUserAgent.length >= 3) {
                                return arrayUserAgent[2];
                            }
                            return '';
                        };

                        const getVendorName = arrayUserAgent => {
                            if (arrayUserAgent && arrayUserAgent.length >= 2) {
                                return arrayUserAgent[1];
                            }
                            return '';
                        };

                        const getFamilyName = arrayUserAgent => {
                            if (arrayUserAgent && arrayUserAgent.length >= 6) {
                                return arrayUserAgent[5];
                            }
                            return '';
                        };

                        const getMacAddress = () => {
                            const appConfig = document.getElementById('oipfcfg');
                            if (!appConfig) return '';
                            let objConfigLocalSystem = undefined;
                            if (appConfig.hasOwnProperty("localSystem")) {
                                objConfigLocalSystem = appConfig.localSystem;
                                if (objConfigLocalSystem.hasOwnProperty("networkInterfaces")) {
                                    return objConfigLocalSystem.networkInterfaces[0].macAddress;
                                }
                            }
                            return '';
                        };

                        const getSoftwareVersion = arrayUserAgent => {
                            if (arrayUserAgent && arrayUserAgent.length >= 4) {
                                return arrayUserAgent[3];
                            }
                            return '';
                        };

                        const userAgent = window.navigator.userAgent;
                        let hbbtvVersionMatch = userAgent.match(/HbbTV\/\d\.(\d).(\d)/g);
                        if (hbbtvVersionMatch === null)
                            hbbtvVersionMatch = 'Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/53.0.2785.34 Safari/537.36 HbbTV/1.4.1 (+DRM+CPAS 2.0.1; LGE; 55SK850V-ZA; WEBOS4.0 03.00.09; W4_M16PP; W4_M16PP;)';
                        const hbbtvVersion = hbbtvVersionMatch[0];

                        let arrayUserAgent = undefined;
                        if (hbbtvVersion) {
                            const temp = userAgent.substring(userAgent.indexOf(hbbtvVersion) + hbbtvVersion.length);
                            let userAgentData = null;
                            if (temp && Array.isArray(temp)) {
                                userAgentData = temp.match(/\(([^)]+)\)/)[1];
                            } else userAgentData = temp;
                            if (userAgentData) {
                                arrayUserAgent = userAgentData.split(";");
                            }
                        }

                        const modelName = getModelName(arrayUserAgent);
                        const vendorName = getVendorName(arrayUserAgent);
                        const familyName = getFamilyName(arrayUserAgent);
                        // const macAddress = getMacAddress();
                        const macAddress = ""
                        const softwareVersion = getSoftwareVersion(arrayUserAgent);

                        body.deviceInfo = {
                            serialNumber: _serial,
                            macAddress,
                            name: "name",
                            userAgent,
                            vendorName,
                            modelName,
                            familyName,
                            connectivityType: "connectivityType",
                            ssid: "ssid",
                            softwareVersion
                        }

                        console.log("[APP STORE][TOKEN] body data", body, urlAuth);
                        if (tokenApp.enabled) {
                            await fetch(urlAuth, {
                                method: "POST",
                                body: JSON.stringify(body)
                            }).then((response) => {
                                return response.json();
                            }).then((respData) => {
                                console.log("[APP STORE][TOKEN] data from service", respData);
                                if (respData.data.token !== undefined) {
                                    document.cookie = `${'kiss-kiss-token-api'}=${respData.data.token};${getExpires((365 * 24 * 60) + (30 * 24 * 60))};path=/`;
                                }
                            }).catch((err) => {
                                console.log("[APP STORE][TOKEN] err request token", err);
                            })
                        }
                    })
                })
            }

            return Promise.resolve({
                federated,
                changeTriggerTimer,
                silente,
                telemetryEnabled,
                activeTestButtons,
                saveOldPrivacyData,
                appVersion,
                channels
            });
        })
});

AppStore.on(getLocalConfig.done, (previousState, newState) => {
    const { result } = newState;
    console.log("CONFIG", result)
    return {
        ...previousState,
        config: result
    }
})

const setShowTrigger = createEffect('set-show-trigger', {
    handler: (val) => {
        return Promise.resolve({
            showTrigger: val
        })
    }
});

AppStore.on(setShowTrigger.done, (prevState, res) => {
    const { result } = res
    return {
        ...prevState,
        showTrigger: result.showTrigger
    }
});

const setShowPolls = createEffect('set-show-polls');

setShowPolls.use((params) => {
    return Promise.resolve({
        showPolls: true
    });
});

AppStore.on(setShowPolls.done, (prevState, res) => {
    const { result } = res;
    return {
        ...prevState,
        showMainApp: false,
        showPolls: true
    }
});

const setShowMainApp = createEffect('set-show-main-app');

setShowMainApp.use(() => {
    return Promise.resolve({
        showMainApp: true
    });
});

AppStore.on(setShowMainApp.done, (prevState, res) => {
    const { result } = res;
    return {
        ...prevState,
        showPolls: false,
        showMainApp: true
    }
});

const getGeoInformations = (url) => {
    if (window.geoInfo !== undefined) {
        return new Promise((resolve) => {
            return resolve(window.geoInfo);
        })
    } else {
        return fetch(url)
            .then(response => {
                return response.json();
            })
            .then(json => {
                console.log('[TELEMETRY] getGeoInformations', url, json)
                return json
            })
            .catch(err => {
                //console.log('err', err)
                return {}
            })
    }
};

export { AppStore, getLocalConfig, setShowTrigger, setShowMainApp, setShowPolls }